import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CreateTransactionRequestDtoV4,
  TransactionRequestV4,
} from '@models/resources/transaction-request.model';

/**
 * Facade für Kauf-/Verkaufs-Anfragen (Customer-Side, V4).
 *
 * Sprint 5c S5c-10/11 — Refactor von V3 auf V4:
 * - Liste liefert `TransactionRequestV4[]` (7 Status, nested `metal`)
 * - Create-DTO ist V4: Buy → `amount_eur`, Sell → `requested_grams`
 *
 * Zwei konkrete Implementierungen (Switch via `environment.dataSource`):
 * - `DummyTransactionRequestsFacade` — In-Memory-Store auf
 *   `DEMO_TRANSACTIONS_V4`, mit Demo-Persistenz beim Submit.
 * - `HttpTransactionRequestsFacade` — fährt gegen
 *   `GET/POST /api/me/transaction-requests`.
 *
 * Admin-Code hat eine eigene Facade (`ADMIN_TRANSACTIONS_FACADE`); diese
 * Customer-Facade wird vom Admin nicht konsumiert.
 */
export type CreateTransactionRequestDto = CreateTransactionRequestDtoV4;

export interface TransactionRequestsFacade {
  list(): Observable<TransactionRequestV4[]>;
  create(dto: CreateTransactionRequestDtoV4): Observable<TransactionRequestV4>;
}

export const TRANSACTION_REQUESTS_FACADE = new InjectionToken<TransactionRequestsFacade>(
  'TransactionRequestsFacade',
);
